import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for switching between different choices
 * in multiple choice field charts without page reload.
 */
export default class extends Controller {
  static targets = ["select"]
  static values = { chartId: String }

  connect() {
    this.chartInstance = null
  }

  switch(event) {
    const selectedOption = event.target.selectedOptions[0]
    const chartData = JSON.parse(selectedOption.dataset.chartData)
    const chartContainer = document.getElementById(this.chartIdValue)
    
    if (!chartContainer) {
      console.warn(`Chart container not found: ${this.chartIdValue}`)
      return
    }

    // Find the Chartkick chart instance
    const chart = Chartkick.charts[this.chartIdValue]
    
    if (chart) {
      // Update the chart data
      chart.updateData(chartData)
    } else {
      // Fallback: re-render the chart
      this.rerenderChart(chartContainer, chartData)
    }
  }

  rerenderChart(container, data) {
    // Clear existing content
    container.innerHTML = ''
    
    // Create new column chart with updated data
    new Chartkick.ColumnChart(container, data, {
      discrete: true,
      stacked: false,
      height: "350px",
      suffix: "%",
      precision: 2,
      library: {
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: "#f0f0f0" }
          }
        },
        plugins: {
          legend: {
            position: "top",
            align: "start"
          },
          tooltip: {
            mode: "index",
            intersect: false
          }
        },
        maintainAspectRatio: false
      }
    })
  }
}

